import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylish%20young%20professional%20sitting%20at%20modern%20wooden%20desk%20with%20laptop%20displaying%20colorful%20product%20spreadsheet%2C%20surrounded%20by%20fashion%20items%20sneakers%20hoodie%20and%20accessories%2C%20bright%20airy%20loft%20apartment%20with%20large%20windows%2C%20natural%20daylight%20flooding%20the%20room%2C%20warm%20beige%20cream%20and%20soft%20olive%20green%20tones%2C%20editorial%20lifestyle%20photography%20with%20genuine%20candid%20feel&width=1600&height=900&seq=hero-main-basetao-v2&orientation=landscape"
          alt="BaseTao Spreadsheet research workspace with product catalog and fashion items"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 text-center py-16 md:py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
          <i className="ri-shield-check-line text-sm text-background-50"></i>
          <span className="text-xs font-medium text-background-50">Independent Research Platform</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5 tracking-tight">
          BaseTao Spreadsheet
          <span className="block text-xl md:text-2xl lg:text-3xl font-medium mt-3 text-background-50/90">
            The Ultimate Guide for Finds, Reviews, Shipping &amp; Savings
          </span>
        </h1>

        <p className="text-sm md:text-base text-background-50/85 max-w-[650px] mx-auto leading-relaxed mb-8">
          Discover the latest BaseTao Spreadsheet resources including product finds, shipping cost guides,
          discount codes, warehouse information, reviews, and beginner tutorials. Your independent research hub
          for smarter shopping decisions.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2"
          >
            <i className="ri-external-link-line"></i>
            Explore BaseTao Spreadsheet
          </a>
          <Link
            to="/articles/basetao-spreadsheet-guide"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 font-medium text-sm rounded-lg border border-background-50/30 hover:bg-background-50/25 transition-all duration-200 cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2"
          >
            <i className="ri-book-open-line"></i>
            Read Beginner Guide
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-8">
          <div className="flex items-center gap-1.5 text-background-50/80 text-xs">
            <i className="ri-checkbox-circle-line text-sm text-accent-400"></i>
            <span>Updated Research</span>
          </div>
          <div className="flex items-center gap-1.5 text-background-50/80 text-xs">
            <i className="ri-checkbox-circle-line text-sm text-accent-400"></i>
            <span>Independent Guide</span>
          </div>
          <div className="flex items-center gap-1.5 text-background-50/80 text-xs">
            <i className="ri-checkbox-circle-line text-sm text-accent-400"></i>
            <span>Shipping Analysis</span>
          </div>
          <div className="flex items-center gap-1.5 text-background-50/80 text-xs">
            <i className="ri-checkbox-circle-line text-sm text-accent-400"></i>
            <span>Safety Information</span>
          </div>
        </div>
      </div>
    </section>
  );
}